import { render, staticRenderFns } from "./AppStoreBadges.vue?vue&type=template&id=40ec2c0a"
import script from "./AppStoreBadges.vue?vue&type=script&lang=js"
export * from "./AppStoreBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports